<template>
  <div class="m-content" >
  	<HeaderBox/>
    <div class="report-content">
      <div class="report-area">
        <p>你选取的4个职业及匹配度为：</p>
        <ul class="label-box">
          <li class="career-label" v-for="(item,index) in cosCareer.listCareer">
            <p class="label-name">{{item.careerName}}</p>
            <p>你与该职位的匹配度：</p>
            <p class="label-score">{{item.iTotalScore}}%</p>
          </li>
        </ul>
      </div>
      <p class="tip" v-if="count>0">有<span>{{count}}</span>个职业匹配度低于<span>60%</span>，建议你慎重选择。</p>
    </div>
  	<FootBox :id="id"/>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'

export default {
  props: {
    id: Number
  },
  name: 'CareerExploreReport',
  components: {
    HeaderBox,
    FootBox
  },
  data() {
    return {
      cosCareer:'',
      count:0
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created: function () {
    setWechatTitle('生涯驿站-职业世界探索')
    this.getReport()
  },
  methods:{
    getReport(){
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosCareerReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            let Result = response.data.data
            if(Result){
              this.cosCareer=Result.cosCareer
              // 弹幕
              let highName = '',high = -1,career = ''
              this.cosCareer.listCareer.map((item,index)=>{
                career+=item.careerName
                if(index<3){
                  career+='、'
                }
                if(item.iTotalScore>high){
                  high = item.iTotalScore
                  highName = item.careerName
                }
                if(item.iTotalScore<60){
                  this.count++
                }
              })
              let num = Math.round(Math.random()*3),
              text = '匹配度最高的职业居然是'+highName
              if(num==1){
                text=highName+'的匹配度居然达到'+high+'%'
              }else if(num==2){
                text='选择了'+career
              }else if(num==3){
                text = '想从事'+career
              }
              store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
            }
          }
        })
        .catch((error)=>{
          console.log(error);
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .tip
    position:fixed
    bottom:2rem
    width: 100%
    max-width: 12rem
    text-align:center
    span
      font-size:0.36rem
  .label-box
    overflow:hidden
    .career-label
      float:left
      width:50%
      background-color:#FF7F00
      p
        color:#ffffff
        text-align:center
        marign:0.2rem auto
      .label-name
        font-size:0.36rem
        height: 1.2rem
        display: flex
        display: -webkit-flex
        justify-content: center
        align-items: center
        -webkit-align-items: center
      .label-score
        font-size:0.56rem
    .career-label:nth-child(2)
      background-color:#7DB0DF
    .career-label:nth-child(3)
      background-color:#C1D659
    .career-label:nth-child(4)
      background-color:#F3A772
</style>
